import React from 'react';
import Carousel from '../components/Carousel';

const aboutText = `Η BLANDA ιδρύθηκε το 2022. Είναι μία Αστική Μη Κερδοσκοπική Εταιρεία πολιτισμού, και δανείζεται το όνομά της από τη βαλκανική ανεμώνη, λουλούδι εφήμερο και όμορφο σαν τη θεατρική πράξη.

H BLANDA δημιουργεί ένα τολμηρό, δυναμικό, πρωτότυπο θέατρο και στοχεύει στη χρήση μίας σύγχρονης θεατρικής γλώσσας που συνδυάζει το λόγο, τη μουσική και την κίνηση. Εξερευνά την ανάγνωση του παρελθόντος, μέσα από κλασικά θεατρικά και λογοτεχνικά κείμενα, αλλά και του παρόντος εφόσον καταπιάνεται με σύγχρονα έργα που αγγίζουν ευαίσθητα κοινωνικά θέματα. Συχνά αναζητά εναλλακτικούς χώρους για το καλλιτεχνικό συμβάν και εξερευνά την κινητοποίηση του θεατή ως ενεργού συμμέτοχου στο καλλιτεχνικό γεγονός.

Τα μέλη της BLANDA πειραματίζονται, ρισκάρουν και δημιουργούν μία θεατρική εμπειρία που επιθυμεί να αγγίξει τον θεατή, να τον ξαφνιάσει, να τον διασκεδάσει και, πιθανόν, να τον παρασύρει σε ένα, μη ενοχικό, δημιουργικό προβληματισμό.

Η ομάδα αποτελείται από ένα δίκτυο καταξιωμένων καλλιτεχνών που εξελίσσουν το καλλιτεχνικό της όραμα και πιστεύουν στη δύναμη της συλλογικής δημιουργίας. Τα μέλη της επιθυμούν να συναντηθούν, να συμπορευθούν και να συνδημιουργήσουν.

Στόχος της BLANDA είναι η παραγωγή και παρουσίαση θεατρικών παραστάσεων και καλλιτεχνικών εργαστηρίων, τόσο στην Ελλάδα όσο και στο εξωτερικό, καθώς και η αναζήτηση διεθνών συνεργασιών με γνώμονα την αυθεντικότητα και την μη επιτήδευση στην παραστατική τέχνη.`;

const paragraphs = aboutText.trim().split('\n\n');

export default function Home() {
  return (
    <div>
      <Carousel />

      {/* About section */}
      <section style={{
        maxWidth: '900px',
        margin: '0 auto',
        padding: '100px 48px 120px',
      }}>
        {/* Decorative rule */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
          marginBottom: '56px',
        }}>
          <div style={{ flex: 1, height: '1px', background: 'var(--light-gray)' }} />
          <span style={{
            fontFamily: 'var(--font-display)',
            fontSize: '0.75rem',
            letterSpacing: '0.22em',
            textTransform: 'uppercase',
            color: 'var(--mid-gray)',
            fontStyle: 'italic',
          }}>Ποιοι Είμαστε</span>
          <div style={{ flex: 1, height: '1px', background: 'var(--light-gray)' }} />
        </div>

        {/* Drop cap first paragraph */}
        {paragraphs.map((para, i) => (
          <p
            key={i}
            style={{
              fontFamily: i === 0 ? 'var(--font-display)' : 'var(--font-body)',
              fontSize: i === 0 ? '1.25rem' : '0.88rem',
              fontWeight: i === 0 ? 400 : 300,
              lineHeight: i === 0 ? 1.75 : 1.95,
              letterSpacing: i === 0 ? '0.02em' : '0.03em',
              color: i === 0 ? 'var(--black)' : 'var(--dark-gray)',
              marginBottom: '28px',
              textAlign: 'justify',
            }}
          >
            {para}
          </p>
        ))}

        {/* Accent line */}
        <div style={{
          marginTop: '56px',
          paddingTop: '40px',
          borderTop: '1px solid var(--light-gray)',
          display: 'flex',
          gap: '48px',
          flexWrap: 'wrap',
        }}>
          {[
            { num: '2022', label: 'Έτος Ίδρυσης' },
            { num: 'ΑΜΚΕ', label: 'Νομική Μορφή' },
            { num: '∞', label: 'Καλλιτεχνική Δέσμευση' },
          ].map(item => (
            <div key={item.num}>
              <div style={{
                fontFamily: 'var(--font-display)',
                fontSize: '2.2rem',
                fontWeight: 300,
                letterSpacing: '0.06em',
                color: 'var(--accent)',
              }}>{item.num}</div>
              <div style={{
                fontSize: '0.62rem',
                letterSpacing: '0.14em',
                textTransform: 'uppercase',
                color: 'var(--mid-gray)',
                marginTop: '4px',
              }}>{item.label}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
